import type { StripeAccountResponse, StripeBalance } from '../types/api'
import { APIFetch, filterResponse, filterResponseBoolean } from '.'

export const getStripeAccountState = async (): Promise<null | StripeAccountResponse> => {
  return filterResponse(await APIFetch('/stripe/accounts', {
    method: 'GET',
    baseUrl: useRuntimeConfig().public.marketplaceApiUrl,
  }))
}

export const createOrUpdateStripeAccount = async (): Promise<null | string> => {
  return filterResponse(await APIFetch('/stripe/accounts', {
    method: 'POST',
    baseUrl: useRuntimeConfig().public.marketplaceApiUrl,
  }))
}

export const getStripeBalance = async (userId?: string): Promise<null | StripeBalance> => {
  if (!userId)
    return null

  return filterResponse(await APIFetch(`/users/${userId}/balance`, {
    method: 'GET',
    baseUrl: useRuntimeConfig().public.marketplaceApiUrl,
  }))
}

export const createStripePayout = async (userId: string): Promise<boolean> => {
  return filterResponseBoolean(await APIFetch(`/users/${userId}/payouts`, {
    method: 'POST',
    baseUrl: useRuntimeConfig().public.marketplaceApiUrl,
  }))
}
